import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {__} from "~/ts/library/Translate";
import OperatorApplicationDialogTextareaButton
    from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialogTextareaButton.vue";
import useTextareaComponent from "~/operatorApplication/vue/dialogs/dialog/textarea/useTextareaComponent";
import toggleClientMute from "~/operatorApplication/ts/service/buddyList/toggleClientMute";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "ToggleMuteButton"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let {client} = useTextareaComponent();

return (_ctx: any,_cache: any) => {
  return (_unref(OperatorAccountStore).checkAccess(_unref(OperatorAccountStore).data.value.accessRights.canToggleMute))
    ? (_openBlock(), _createBlock(OperatorApplicationDialogTextareaButton, {
        key: 0,
        icon: _unref(client).isMuted ? 'volume' : 'volume-mute',
        tooltip: _unref(client).isMuted ? _unref(__)('Включить уведомления') :_unref(__)('Отключить уведомления'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => {_unref(toggleClientMute)(_unref(client));})
      }, null, 8, ["icon", "tooltip"]))
    : _createCommentVNode("", true)
}
}

})